import { render } from "./WorldMapSVG.vue?vue&type=template&id=37bb3d6a&scoped=true"
import script from "./WorldMapSVG.vue?vue&type=script&lang=js"
export * from "./WorldMapSVG.vue?vue&type=script&lang=js"

import "./WorldMapSVG.vue?vue&type=style&index=0&id=37bb3d6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bb3d6a"]])

export default __exports__